import { Grid, Paper, Button } from "@mui/material";
import DynamicForm from "shared/organisms/dynamicform";
import useReactHookForm from "hooks/useReactHookForm";
import ContentRight from "shared/molecules/content-right";
import { hasAtLeastOneValue, sessionAllocationInitialValues, sessionAllocationProperties, sessionAllocationValidationSchema } from "./helper";
import { formatDateUtc } from "utils/time-util/utcIstTime";


export function SessionAllocationFilter({setSearchPayload,
  setPage,
  }) {

  const { control, errors, getValues, watch, setValue } = useReactHookForm(
    sessionAllocationInitialValues,
    sessionAllocationValidationSchema,
    "",
  );

  const handleSearch =()=>{

    const payload:any={};

    const vendorUserId= watch("vendorUserId");
    if(vendorUserId) payload.vendorUserId=parseInt(vendorUserId);

    const allocationStatus= watch("allocationStatus");
    if(allocationStatus) payload.allocationStatus=allocationStatus;

    const userType= watch("userType");
    if(userType) payload.userType=userType;

    const entityType= watch("entityType");
    if(entityType) payload.entityType=entityType;

    const bufferAt = watch("buffer_at");
    if(bufferAt?.[0]) payload.bufferedStartFrom=formatDateUtc(bufferAt[0]);
    if(bufferAt?.[1]) payload.bufferedStartTill=formatDateUtc(bufferAt[1], true);

    const actualAt = watch("actual_at");
    if(actualAt?.[0]) payload.actualStartFrom=formatDateUtc(actualAt[0]);
    if(actualAt?.[1]) payload.actualStartTill=formatDateUtc(actualAt[1], true);

    const createdAt = watch("created_at");
    if (createdAt?.[0]) payload.createdFrom = formatDateUtc(createdAt[0]);
    if (createdAt?.[1]) payload.createdTill = formatDateUtc(createdAt[1], true);

    const updatedAt = watch("updated_at");
    if(updatedAt?.[0]) payload.updatedFrom=formatDateUtc(updatedAt[0]);
    if(updatedAt?.[1]) payload.updatedTill=formatDateUtc(updatedAt[1], true);

    setSearchPayload(payload);
    setPage(1);
  }

  const clearFilter = () =>{
    setValue("liveSessionId","")
    setValue("vendorUserId","")
    setValue("allocationStatus","")
    setValue("userType","")
    setValue("entityType","")
    setValue("created_at",[null, null]);
    setValue("updated_at",[null, null]);
    setValue("buffer_at",[null, null])
    setValue("actual_at",[null, null])
    setSearchPayload({});
    setPage(1);
  }

  return (
    //
    <div>
      <Paper elevation={2} sx={{ px: 2, pb: 3, pt:3 }}>
        <Grid container spacing={2}>
          <DynamicForm
            fields={sessionAllocationProperties}
            control={control}
            errors={errors}
            watch={watch}
            setValue={setValue}
            getValues={getValues}
          />

          <ContentRight sx={{ mt: -7 }}>
            <Button
              variant="contained"
              sx={{
                width: "70px",
                height: "40px",
                marginTop: "75px",
                marginRight: "10px",
                padding: "7px 42.5px 7px 48.5px",
                cursor: "pointer",
                textAlign: "center",
              }}
              onClick={clearFilter}
              disabled={!hasAtLeastOneValue(watch(),["allocationStatus", "userType","entityType","buffer_at", "actual_at", "created_at", "updated_at"]) || Object.keys(errors).length > 0}
            >
              clear
            </Button>
            <Button
              variant="contained"
              sx={{
                width: "80px",
                height: "40px",
                marginTop: "75px",
                padding: "7px 42.5px 7px 48.5px",
                cursor: "pointer",
                textAlign: "center",
              }}
              onClick={handleSearch}
              disabled={!hasAtLeastOneValue(watch(), ["allocationStatus", "userType","entityType","buffer_at", "actual_at", "created_at", "updated_at"]) || Object.keys(errors).length > 0}
            >
              search
            </Button>
          </ContentRight>
        </Grid>
      </Paper>
    </div>
  );
}
